// extracted by mini-css-extract-plugin
module.exports = {"posts":"blogposts-module--posts--2pLU9","postcounter":"blogposts-module--postcounter--9q9Eu","post":"blogposts-module--post--SxZGp"};